if (!customElements.get("shipping-bar")) {
  customElements.define(
    "shipping-bar",
    class ShippingBar extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.amount_els = this.querySelectorAll(".value");
        this.cartDraw =
          this.closest("cart-drawer") || this.closest(".ca__free-shipping");

        if (!this.cartDraw) return; //attached to cartDraw as rest gets rebuilt

        this.setSize();
      }

      setSize() {
        var limit = parseInt(this.dataset.limit);
        var total = this.dataset.potentialItems
          ? parseInt(this.dataset.cartTotal) +
            parseInt(this.dataset.potentialItems)
          : parseInt(this.dataset.cartTotal);

        var distance = (total / limit) * 100;

        var current_location =
          document.querySelector("main")?.dataset.location ?? "en";
        var current_currency =
          document.querySelector("main")?.dataset.currency ?? "AUD";

        Array.from(this.amount_els).forEach((amount_el) => {
          let money = new Intl.NumberFormat(current_location, {
            style: "currency",
            currency: current_currency,
            currencyDisplay: "narrowSymbol",
          });
          //amount_el.innerHTML = Shopify.formatMoney(limit - total);
          amount_el.innerHTML = money.format((limit - total) / 100);
        });

        //set size property on cart draw as the rest gets replaced
        setTimeout(() => {
          //timeout to ensure element has be rendered
          this.cartDraw.style.setProperty(
            "--shipping-distance",
            `${distance > 100 ? 100 : distance}%`,
          );
          this.cartDraw.dataset.distance = distance > 100 ? 100 : distance;
        }, 0);
      }
    },
  );
}
